import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="max-w-4xl mx-auto px-6 py-10 space-y-8">
        <div>
          <h1 className="text-3xl font-bold font-poppins text-[#1A1A1A]">Privacy Policy</h1>
          <p className="text-sm text-[#777777] mt-2">Last updated: May 8, 2026</p>
        </div>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">1. Overview</h2>
          <p>
            This Privacy Policy describes how Kipr collects, uses, and protects information when you use our training platform,
            demo experiences, and subscription services.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">2. Information We Collect</h2>
          <p>We may collect account and profile data, including name, email, and role.</p>
          <p>
            We collect usage and product telemetry, including training session metadata, generated reports, and interaction history needed
            to provide and improve the service.
          </p>
          <p>
            For voice features, audio/transcript artifacts and derived analytics may be processed by integrated service providers used by Kipr.
          </p>
          <p>Billing data is processed by Stripe. We receive limited subscription metadata, not full payment card details.</p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">3. How We Use Information</h2>
          <p>We use collected data to operate the service, authenticate users, deliver reports, and maintain account access.</p>
          <p>We use information for security monitoring, abuse prevention, troubleshooting, and customer support.</p>
          <p>We may use aggregated or de-identified data to improve product quality and model/system performance.</p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">4. Service Providers</h2>
          <p>
            Kipr relies on trusted infrastructure and application vendors (such as hosting, authentication, billing, voice, and AI providers)
            to deliver features. These providers process data under contractual and technical controls appropriate to their role.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">5. Data Retention</h2>
          <p>
            We retain data for as long as needed to provide services, comply with legal obligations, resolve disputes, and enforce agreements.
            Retention windows may vary by data type and account status.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">6. Security</h2>
          <p>
            We use reasonable administrative, technical, and organizational safeguards to protect information. No method of transmission or storage
            is completely secure, and absolute security cannot be guaranteed.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">7. Your Choices and Rights</h2>
          <p>You can update profile information from your account and manage billing through the Stripe customer portal.</p>
          <p>
            Depending on your location, you may have rights to request access, correction, deletion, or portability of personal information,
            subject to legal limitations.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">8. Children&apos;s Privacy</h2>
          <p>
            Kipr is intended for professionals, trainees, and authorized users. The service is not directed to children under 13,
            and we do not knowingly collect personal information directly from children under 13.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">9. Policy Updates</h2>
          <p>We may update this Privacy Policy from time to time. Material changes will be reflected by an updated effective date.</p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">10. Contact</h2>
          <p>Privacy questions and data requests can be sent to privacy@kipr.app.</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
